import { Box, Grid } from '@mui/material';
import React, { useCallback } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

export default function TabJefeCalidad({
    onChange,
    reclamoFormData,
    editable
}) {

    const handleInputChange = useCallback((fieldName, value) => {
        onChange({
            [fieldName]: value,
        });
    }, []);

    return (
        <div>
            <Grid container spacing={2}>
 <Grid size={{ xs: 12 }}>
                    <RenderInputByTypeMobile
                        input={{
                            name: 'observacionFinal',
                            displayName: 'Observación final',
                            type: 'long_string',
                            required: true,
                            disabled: !editable
                        }}
                        handleChange={handleInputChange}
                        value={reclamoFormData?.stage5?.observacionFinal || ''}
                    />
                </Grid>
            </Grid>
        </div>
    )
}